import Vector3 from './Vector3.js';

export default class Vector4 {
	constructor (x, y, z, w) {
		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;
	}

	set (x, y, z, w) {
		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;
		return this;
	}

	// setArray (arr) {
	// 	this.x = arr[0];
	// 	this.y = arr[1];
	// 	this.z = arr[2];
	// 	this.w = arr[3];
	// 	return this;
	// }

	// toString () {
	// 	return '[' + this.x + ', ' + this.y + ', ' + this.z + ', ' + this.w + ']';
	// }

	toNormalizedDeviceCoordinates () {
		var x = this.x / this.w;
		var y = this.y / this.w;
		var z = this.z / this.w;
		var w = 1 / this.w;
		return new Vector4(x, y, z, w);
	}

	toWindowCoordinates (viewport, depthRange) {
		var x = viewport.z / 2 * this.x + viewport.x + viewport.z / 2;
		var y = viewport.w / 2 * this.y + viewport.y + viewport.w / 2;
		var z = (depthRange.y - depthRange.x) * 0.5 * this.z + (depthRange.y + depthRange.x) * 0.5;
		return new Vector3(x, y, z);
	}

	toVector3 () {
		return new Vector3(this.x, this.y, this.z);
	}

	normalizePlane () {
		var magnitude = Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
		this.x /= magnitude;
		this.y /= magnitude;
		this.z /= magnitude;
		this.w /= magnitude;
	}

	copy () {
		return new Vector4(this.x, this.y, this.z, this.w);
	}
}


// Vector4.lerp = function (t, vec4a, vec4b) {
// 	return new Vector4(
// 		vec4a.x * (1 - t) + vec4b.x * t,
// 		vec4a.y * (1 - t) + vec4b.y * t,
// 		vec4a.z * (1 - t) + vec4b.z * t,
// 		vec4a.w * (1 - t) + vec4b.w * t
// 	);
// };
